import React, { useState  , useContext, useEffect} from 'react'
import  Language  from './Context/Language'
import  DataFetch  from './Context/DataFetch'
import Loading from './components/Loading'
import axios from "axios";
import {
    useLocation
  } from "react-router-dom";

export default function Ptmobile() {
    const [FixtureSelection , setFixtureSelection] = useState("total")
    const {loading } = useContext(DataFetch)
    const {PointTable , data , ApiUrl} = useContext(DataFetch)
    const dataLang = useContext(Language);
    const [PointTablePt , setPointTablePt] = useState([])
    const [LoadingPoint , setLoadingPoint] = useState(true)
    const [datah2h , setdatah2h] = useState([])
    const [title, setTitle] = useState("SR-PT");


    const location = useLocation();
    const PointTableDataFuncPt = async () => {
        let sportId = location.pathname.split("/")[3]
        let categoryId = location.pathname.split("/")[4]
        let tourId = location.pathname.split("/")[5]
        try {
          const {data} = await axios.get(`${ApiUrl}/api/LeaguePointTable/${sportId}/${categoryId}/${tourId}/${sessionStorage.getItem("lang")}`);
          setPointTablePt(data.params.result)
          setLoadingPoint(false)

        } catch (error) {
        }
        };

        const DataH2hFunc = async () => {
            var date = new Date();
            var offsetInMinute = (date.getTimezoneOffset() / 60 ) *60;
            try {
              const {data} = await axios.get(`${ApiUrl}/api/H2H?matchId=${location.pathname.split("/")[2]}&lang=${sessionStorage.getItem("lang")}&timezone=${offsetInMinute > 0 ? -Math.abs(offsetInMinute) : Math.abs(offsetInMinute) }`);
              if(data.isScreenValidate === true) {
                setdatah2h(data.params.result)
              }
            
            } catch (error) {
            }
            };

        useEffect(() => {
            PointTableDataFuncPt();
            DataH2hFunc();
            document.title = title;
        },[title])


    const Avantage = (a,b) => {
                return a-b
    }

    const TotalPoint  = () => {
      setFixtureSelection("total")
    }

    const HomePoint  = () => {
      setFixtureSelection("home")
    }
    const AwayPoint  = () => {
      setFixtureSelection("away")
    }

  return (
    LoadingPoint ? 
    <div className='H2HRootContainerArea'>
    <Loading/>
   </div>

    :

    PointTablePt.length !==0 ?
    <div className='OverviewContainer pt'>
        <div className='OverviewContainerHeaderArea ptmobileBack'>
            <div className='OverviewContainerAlt ptAlt'>
            <div id='total' onClick={TotalPoint} className={`OverviewContainerAltHead ${FixtureSelection === "total" ? "activeButtonFixtureAlt" : ""}`}><span className="OverviewTab">{dataLang[sessionStorage.getItem("lang")].Total}</span></div>
            <div id="home"onClick={HomePoint} className={`OverviewContainerAltHead ${FixtureSelection === "home" ? "activeButtonFixtureAlt" : ""}`}><span className="OverviewTab">{dataLang[sessionStorage.getItem("lang")].Home}</span></div>
            <div id='away' onClick={AwayPoint} className={`OverviewContainerAltHead ${FixtureSelection === "away" ? "activeButtonFixtureAlt" : ""}`}><span className="OverviewTab">{dataLang[sessionStorage.getItem("lang")].Away}</span></div>
            </div>

            <div className='OverviewPointTable'>


              <div className='PointTableHeaderArea  ptHeader'>
                <div className='PointsTableNoRow'>{dataLang[sessionStorage.getItem("lang")].No}</div>
                <div className='PointsTableTeamsRow'>{dataLang[sessionStorage.getItem("lang")].Team}</div>
                <div className='PointsTablePlayedRow'>{dataLang[sessionStorage.getItem("lang")].P}</div>
                <div className='PointsTableWonRow'>{dataLang[sessionStorage.getItem("lang")].W}</div>
                <div className='PointsTableDrawnRow'>{dataLang[sessionStorage.getItem("lang")].D}</div>
                <div className='PointsTableLostRow'>{dataLang[sessionStorage.getItem("lang")].L}</div>
                <div className='PointsTableGFRow'>{dataLang[sessionStorage.getItem("lang")].GF}</div>
                <div className='PointsTableGARow'>{dataLang[sessionStorage.getItem("lang")].GA}</div>
                <div className='PointsTableGDRow'>{dataLang[sessionStorage.getItem("lang")].GD}</div> 
                <div className='PointsTablePointsRow'>P</div>
                <div className='PointsTableFormsRow'>Form</div>
              </div>
              {
                  PointTablePt.sort((b,a) => (FixtureSelection === "total" ? ( a.pointsTotal > b.pointsTotal ? 1 : a.pointsTotal === b.pointsTotal ? Avantage(a.goalsTotal.split(":")[0],a.goalsTotal.split(":")[1] )  > Avantage(b.goalsTotal.split(":")[0],b.goalsTotal.split(":")[1] )  ?  1 : Avantage(a.goalsTotal.split(":")[0],a.goalsTotal.split(":")[1] ) === Avantage(b.goalsTotal.split(":")[0],b.goalsTotal.split(":")[1] ) ? a.goalsTotal.split(":")[0] < b.goalsTotal.split(":")[0] ? 1 :  a.teamName > b.teamName : -1:-1 ) 
                  :FixtureSelection==="home"?(a.pointsHome > b.pointsHome ? 1 : a.pointsHome === b.pointsHome ? Avantage(a.goalsHome.split(":")[0],a.goalsHome.split(":")[1] )  > Avantage(b.goalsHome.split(":")[0],b.goalsHome.split(":")[1] )  ?  1 : Avantage(a.goalsHome.split(":")[0],a.goalsHome.split(":")[1] ) === Avantage(b.goalsHome.split(":")[0],b.goalsHome.split(":")[1] ) ? a.goalsHome.split(":")[0] > b.goalsHome.split(":")[0] ? 1 : a.teamName > b.teamName  :-1: -1    ) 
                  :(a.pointsAway > b.pointsAway ? 1 : a.pointsAway === b.pointsAway ? Avantage(a.goalsAway.split(":")[0],a.goalsAway.split(":")[1] )  > Avantage(b.goalsAway.split(":")[0],b.goalsAway.split(":")[1] )  ?  1 : Avantage(a.goalsAway.split(":")[0],a.goalsAway.split(":")[1] ) === Avantage(b.goalsAway.split(":")[0],b.goalsAway.split(":")[1] ) ? a.goalsAway.split(":")[0] > b.goalsAway.split(":")[0] ? 1 : a.teamName > b.teamName  :-1: -1    ) )).map(function(item, i){
                    return <div key={i} className='PointTableTeamsArea ptTeamsLine' id={`${item.teamId === datah2h.homeTeamId || item.teamId === datah2h.awayTeamId ? "selectedTeam":"" }`}>
                    <div className={(item.promotion==="Champions League" || item.promotion === "Promotion" || item.promotion ==="Qualified" || item.promotion === "Championship round" || item.promotion ==="Semifinal") && FixtureSelection ==="total" ?'PointsTableNoRowChamp':
                      (item.promotion==="Champions League Qualification" || item.promotion ==="Promotion Playoffs" || item.promotion ==="Qualifying round" || item.promotion ==="Playoffs")  && FixtureSelection ==="total" ?'PointsTableNoRowChampQual':
                      item.promotion==="UEFA Europa League" && FixtureSelection ==="total" ?'PointsTableNoRowChampUefa':
                      item.promotion==="UEFA Europa League Qualification" && FixtureSelection ==="total" ?'PointsTableNoRowChampUefaQual':
                      item.promotion==="UEFA Conference League" && FixtureSelection ==="total" ?'PointsTableNoRowChampConfe':
                      item.promotion==="UEFA Conference League Qualification" && FixtureSelection ==="total" ?'PointsTableNoRowChampConfeQual':
                      item.promotion==="Relegation" && FixtureSelection ==="total" ?'PointsTableNoRowRelegation':
                       "PointsTableNoRow"} >{i+1}</div>
                    <div className='PointsTableTeamsRow'><img src={`https://cdn-images.nvpark.com/logo/${item.teamId}.png`} width={21} height={21} alt=''></img><div className='PointTableTeamText'>{item.teamName}</div></div>
                    <div className='PointsTablePlayedRow'>{FixtureSelection === "total" ?item.playedTotal : FixtureSelection === "home" ? item.playedHome : item.playedAway}</div>
                    <div className='PointsTableWonRow'>{FixtureSelection === "total" ? item.winsTotal : FixtureSelection === "home" ? item.winsHome : item.winsAway}</div>
                    <div className='PointsTableDrawnRow'>{FixtureSelection === "total" ?item.drawsTotal : FixtureSelection === "home" ? item.drawsHome : item.drawsAway}</div>
                    <div className='PointsTableLostRow'>{FixtureSelection === "total" ?item.lossesTotal: FixtureSelection ==="home" ? item.lossesHome :item.lossesAway}</div>
                    <div className='PointsTableGFRow'>{FixtureSelection==="total" ? item.goalsTotal.split(":")[0] : FixtureSelection ==="home" ? item.goalsHome.split(":")[0] :item.goalsAway.split(":")[0]  }</div>
                    <div className='PointsTableGARow'>{FixtureSelection === "total" ? item.goalsTotal.split(":")[1] : FixtureSelection ==="home" ? item.goalsHome.split(":")[1] : item.goalsAway.split(":")[1]}</div>
                    <div className='PointsTableGDRow'>{FixtureSelection === "total" ?Avantage(item.goalsTotal.split(":")[0],item.goalsTotal.split(":")[1]) : FixtureSelection ==="home" ?Avantage(item.goalsHome.split(":")[0],item.goalsHome.split(":")[1]) :Avantage(item.goalsAway.split(":")[0],item.goalsAway.split(":")[1])}</div>
                    <div className='PointsTablePointsRow'>{FixtureSelection ==="total" ?item.pointsTotal :FixtureSelection === "home" ? item.pointsHome : item.pointsAway}</div>
                  </div>
                  })
              }
            </div>
           
            {
             PointTablePt[0].promotion ==="Promotion" ?
             <div className='PointTableStateManage'> 
             <div className='firstContainerCham'>
               <div className='Ptt'><div id='firstContainerCham'></div> <div>{dataLang[sessionStorage.getItem("lang")].Promotion}</div></div>
               <div className='Ptt'><div id='firstContainerChamQual'></div><div>{dataLang[sessionStorage.getItem("lang")].PromotionPlayoffs}</div></div>
               <div className='Ptt'><div id='firstContainerRela'></div> <div>{dataLang[sessionStorage.getItem("lang")].Relegation}</div></div>
             </div>
           </div>
 
            :

            PointTablePt[0].promotion === "Qualified" ? 
            <div className='PointTableStateManage'> 
            <div className='firstContainerCham'>
              <div className='Ptt'><div id='firstContainerCham'></div> <div>{dataLang[sessionStorage.getItem("lang")].Qualified}</div></div>
            </div>
          </div>

            
            :

            PointTablePt[0].promotion === "Championship round" ? 
            <div className='PointTableStateManage'> 
            <div className='firstContainerCham'>
              <div className='Ptt'><div id='firstContainerCham'></div> <div>{dataLang[sessionStorage.getItem("lang")].Championshipround}</div></div>
              <div className='Ptt'><div id='firstContainerChamQual'></div> <div>{dataLang[sessionStorage.getItem("lang")].Qualifyinground}</div></div>
              <div className='Ptt'><div id='firstContainerRela'></div> <div>{dataLang[sessionStorage.getItem("lang")].Relegation}</div></div>
            </div>
          </div>

   :

   PointTablePt[0].promotion === "Semifinal" ? 
   <div className='PointTableStateManage'> 
   <div className='firstContainerCham'>
     <div className='Ptt'><div id='firstContainerCham'></div> <div>{dataLang[sessionStorage.getItem("lang")].Semifinal}</div></div>
     <div className='Ptt'><div id='firstContainerChamQual'></div> <div>{dataLang[sessionStorage.getItem("lang")].Playoffs}</div></div>
   </div>
 </div>

:

PointTablePt[0].promotion === "Champions League" || PointTablePt[0].promotion === "Champions League Qualification"  ||PointTablePt[0].promotion === "UEFA Europa League" || PointTablePt[0].promotion === "UEFA Europa League Qualification"  ? 
<div className='PointTableStateManage'> 
<div className='firstContainerCham'>
  <div className='Ptt'><div id='firstContainerCham'></div> <div>{dataLang[sessionStorage.getItem("lang")].ChampionsLeague}</div></div>
  <div className='Ptt'><div id='firstContainerChamQual'></div><div>{dataLang[sessionStorage.getItem("lang")].ChampionsLeagueQualification}</div></div>
  <div className='Ptt'><div id='firstContainerRela'></div> <div>{dataLang[sessionStorage.getItem("lang")].Relegation}</div></div>
</div>
<div className='firstContainerCham'>
  <div className='Ptt'><div id='firstContainerUefa'></div> <div>{dataLang[sessionStorage.getItem("lang")].UEFAEuropaLeague}</div></div>
<div className='Ptt'><div id='firstContainerUefaQual'></div> <div>{dataLang[sessionStorage.getItem("lang")].UEFAEuropaLeagueQualification}</div></div>
</div>
<div className='firstContainerCham'>
<div className='Ptt'><div id='firstContainerUefaCon'></div> <div>{dataLang[sessionStorage.getItem("lang")].UEFAConferenceLeague}</div></div>
<div className='Ptt'><div id='firstContainerUefaConQual'></div> <div>{dataLang[sessionStorage.getItem("lang")].UEFAConferenceLeagueQualification}</div></div>
</div>
</div>

:
""
            }

         
        </div>
    </div>
    :
    <div className='H2HRootContainerArea'>
    <div className='NoPointTableData'>
         <div>{dataLang[sessionStorage.getItem("lang")].NOPOİNTTABLEDATA}</div>
    </div>
    </div>
  )
}
